import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { Component } from 'vue-property-decorator'
import { BaseStore } from '@/store/modules/Base'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: '首页',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "home" */ '../pages/Home/index.vue')
  },
  {
    path: '/login',
    name: '登录',
    component: () => import(/* webpackChunkName: "Login" */ '../pages/Login/index.vue')
  },
  {
    path: '/recharge',
    name: '充值中心',
    meta: {
      footer: true,
      NavBar: false, // 显示顶部导航栏
      Sidebar: false // 侧栏
    },
    component: () => import(/* webpackChunkName: "Recharge" */ '../pages/Recharge/index.vue')
  },
  {
    path: '/live',
    name: '直播中心',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Live" */ '../pages/Live/index.vue')
  },
  {
    path: '/liveDetail',
    name: '直播间详情',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: false // 侧栏
    },
    component: () => import(/* webpackChunkName: "Live" */ '../pages/Live/detail.vue')
  },
  {
    path: '/exchange',
    name: '权益中心',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Exchange" */ '../pages/Exchange/index.vue')
  },
  {
    path: '/exchangeDetail',
    name: '权益详情',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: false // 侧栏
    },
    component: () => import(/* webpackChunkName: "Exchange" */ '../pages/Exchange/detail.vue')
  },
  {
    path: '/cash',
    name: '提现中心',
    meta: {
      footer: true,
      NavBar: false, // 显示顶部导航栏
      Sidebar: false // 侧栏
    },
    component: () => import(/* webpackChunkName: "Cash" */ '../pages/Cash/index.vue')
  },
  {
    path: '/cash/withdrawRecord',
    name: '交易记录',
    meta: {
      footer: true,
      NavBar: false, // 显示顶部导航栏
      Sidebar: false // 侧栏
    },
    component: () => import(/* webpackChunkName: "Cash" */ '../pages/Cash/withdrawRecord.vue')
  },
  {
    path: '/tradedetail',
    name: '交易明细',
    meta: {
      footer: true,
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Business" */ '../pages/TradeDetail/index.vue')
  },
  {
    path: '/business',
    name: '商户中心',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/index.vue'),
    redirect: '/business/info',
    children: [
      {
        path: 'info',
        name: '商户中心',
        meta: {
          footer: true,
          NavBar: true, // 显示顶部导航栏
          Sidebar: true // 侧栏
        },
        component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/pages/BusinessInfo/index.vue')
      },
      {
        path: 'prod',
        name: '我的产品',
        meta: {
          footer: true,
          NavBar: true, // 显示顶部导航栏
          Sidebar: true // 侧栏
        },
        component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/pages/BusinessProd/index.vue')
      },
      {
        path: 'association',
        name: '关联商家',
        meta: {
          footer: true,
          NavBar: true, // 显示顶部导航栏
          Sidebar: true // 侧栏
        },
        component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/pages/Association/index.vue')
      },
      {
        path: 'merchant/:saas?/:id?',
        name: '商家主页',
        meta: {
          footer: true,
          NavBar: true, // 显示顶部导航栏
          Sidebar: true // 侧栏
        },
        component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/pages/Merchant/index.vue')
      },
      {
        path: 'message',
        name: '系统消息',
        meta: {
          footer: true,
          NavBar: true // 显示顶部导航栏
        },
        component: () => import(/* webpackChunkName: "Business" */ '../pages/Business/pages/Message/index.vue')
      }
    ]
  },
  {
    path: '/search',
    name: '产品搜索',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Search" */ '../pages/Search/index.vue')
  },
  {
    path: '/bailing',
    name: '百灵文旅',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Search" */ '../pages/Search/index.vue')
  },
  {
    path: '/foods',
    name: '惠食仓',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Search" */ '../pages/Foods/index.vue')
  },
  {
    path: '/supermarket',
    name: '精选好货',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Search" */ '../pages/Supermarket/index.vue')
  },
  {
    path: '/hotel',
    name: '精品酒店',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Hotel" */ '../pages/Hotel/index.vue')
  },
  {
    path: '/hotelList',
    name: '酒店列表',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Hotel" */ '../pages/Hotel/list.vue')
  },
  {
    path: '/hotelDetail',
    name: '酒店详情',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Hotel" */ '../pages/Hotel/detail.vue')
  },
  {
    path: '/hotelReserve',
    name: '酒店下单',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Hotel" */ '../pages/Hotel/reserve.vue')
  },
  {
    path: '/ticket',
    name: '门票集合',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Ticket" */ '../pages/Ticket/index.vue')
  },
  {
    path: '/ticketList',
    name: '门票列表',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Ticket" */ '../pages/Ticket/list.vue')
  },
  {
    path: '/ticketDetail',
    name: '门票详情',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Ticket" */ '../pages/Ticket/detail.vue')
  },
  {
    path: '/platform',
    name: '平台合集',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Platform" */ '../pages/Platform/index.vue')
  },
  {
    path: '/platformIndex',
    name: '平台产品列表',
    meta: {
      keepAlive: true,
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Platform" */ '../pages/Platform/list.vue')
  },
  {
    path: '/documentPage',
    name: '规则文档',
    meta: {
      footer: true,
      NavBar: true, // 显示顶部导航栏
      Sidebar: true // 侧栏
    },
    component: () => import(/* webpackChunkName: "Search" */ '../pages/DocumentPage/index.vue')
  }
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  // mode: 'history', // 旧版使用hash模式，为兼容旧版路径
  base: process.env.BASE_URL,
  routes
})

// 重复点击导航时，控制台报错
const originalPush: any = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  if (!BaseStore.tokenData.token && to.path !== '/login') {
    Vue.prototype.$message({
      message: '请先登录!',
      type: 'error'
    })
    router.replace({
      path: `/login?fullPath=${encodeURIComponent(location.hash.replace(/^#/, ''))}`
    })
    next()
  } else {
    if (to.name) document.title = to.name
    next()
  }
})

export default router
